import browser from 'detect-browser'

export const getBrowserAndVersion = () => {
  return `${browser.name} v${browser.version}`
}

export const getVersion = () => {
  if (browser) {
    const parts = browser.detect().version.split('.')
    return {
      major: parts[0],
      minor: parts[1],
      build: parts[2]
    }
  }
}

export const isBrowserSupported = () => {
  if (!browser) {
    // browser so old it doesn't even support browser
    return false
  }
  const v = getVersion()

  switch (browser.detect().name) {
    case 'chrome':
      return v.major > 50
    case 'firefox':
      return v.major > 34
    case 'edge':
      return v.major > 13
    case 'ie':
      if (document.documentMode > 10) {
        return v.major > 10
      } else {
        return false
      }
    case 'safari':
    case 'ios':
      return v.major > 8
    case 'crios':
      return v.major > 46
    case 'opera':
      return v.major > 46
    default:
      // denying browser support based on name alone
      return false
  }
}



// WEBPACK FOOTER //
// ./src/util/BrowserInfo.js